export default {
  inputHeight: '42px',
  borderRadius: '4px',
  sidebarWidth: '28%',
  tabletSidebarWidth: '52px' 
};
